import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

//  Services
import { AuthenticationService } from './services/authentication.service';
import { LookupService } from './services/lookup.service';
import { StorageService } from './services/storage.service';

// Shared
import {parseCurrentUrlAndGetYear} from './shared/helpers.util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  activeRoute: string;
  public options = {
    timeOut: 1000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: false,
    maxLength: 60,
    position: ["bottom", "left"]
  };

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private storageService: StorageService,
    private lookupService: LookupService) {
    var BASE_PATH = 'https://aams-api.nprb.org/a';
    window.location.href.includes('test.nprb.org') ? BASE_PATH = 'https://aams-api.test.nprb.org/a' : 
    window.location.href.includes('localhost') || window.location.href.includes('dev') ? BASE_PATH = 'http://localhost:8081/a' : BASE_PATH = 'https://aams-api.nprb.org/a';
    
    this.storageService.store('rootApiUrl', BASE_PATH);
    this.storageService.store('amssApiUrl', BASE_PATH + '/amss');
    this.storageService.store('year', parseCurrentUrlAndGetYear());
    this.lookupService.retrieveSymposiumForCurrentYear(BASE_PATH + '/amss', parseCurrentUrlAndGetYear() )
      .subscribe(response => {
        this.storageService.store('symposium', response.json());
      }, err => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.activeRoute = this.router.url;
  }

  signOut() {
    this.authService.clearSession();
    this.router.navigate(['']);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts